export default __webpack_public_path__ + "static/media/candle.fbb9bfa6.gif";